import React from 'react';
import { DraggableTool } from './DraggableTool';
import type { ToolConfig } from '../schemas';

export interface ToolsOverlayProps {
  tools: ToolConfig[];
  /**
   * Bump this number to reset all tool positions / rotations / flip state.
   * Each DraggableTool is keyed as `{id}-{resetKey}`, so a change causes React
   * to unmount + remount it — identical to how resetKey works for other widgets.
   */
  resetKey?: number;
  className?: string;
}

/**
 * Container for draggable tools that overlays the exercise area.
 * Tools can be freely positioned and rotated within this container.
 */
export const ToolsOverlay: React.FC<ToolsOverlayProps> = ({
  tools,
  resetKey = 0,
  className = '',
}) => {
  if (tools.length === 0) return null;

  return (
    <div className={`tools-overlay ${className}`}>
      {tools.map((tool) => (
        <DraggableTool
          key={`${tool.id}-${resetKey}`}
          id={tool.id}
          type={tool.type}
          imageSrc={tool.imageSrc}
          initialPosition={tool.initialPosition}
          initialRotation={tool.initialRotation}
          width={tool.width}
        />
      ))}
    </div>
  );
};
